import { Theme, styled } from "@mui/material/styles"

export const StyledAppVersion = styled("div")`
  color: ${props => (props.theme as Theme).palette.text.secondary};
  font-style: italic;
  font-size: 0.8em;
`
